import { render, staticRenderFns } from "./Order_show.vue?vue&type=template&id=3f7193f7&scoped=true"
import script from "./Order_show.vue?vue&type=script&lang=js"
export * from "./Order_show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7193f7",
  null
  
)

export default component.exports